import React from 'react';
import AboutHero from '../components/AboutHero';
import WhySection from '../components/WhySection';
import StartFree from '../components/StartFree';
import PartnerSection from '../components/PartnerSection';
import ValuesSection from '../components/ValuesSection';
import QuoteForm from '../components/QuoteForm';

const Home = () => {
  return (
    <>
      <AboutHero />
      <WhySection />
      <StartFree />
      <PartnerSection />
      <ValuesSection />
      <QuoteForm />
      <div className="bottom-cta">
        <p>
          <i className="fas fa-arrow-right"></i>
          Ready to source globally, stay compliant, and reduce emissions?
          <a href="#quote" className="btn-eu" style={{ marginLeft: '0.5rem', fontSize: '0.75rem', padding: '0.3rem 1.2rem', display: 'inline-block' }}>
            Start Your RFQ
          </a>
        </p>
      </div>
    </>
  );
};

export default Home;